<template>
    <div class="home-container">
        <section class="d-flex align-items-center gap-3">
            <primaryButtonComponent v-for="(data, i) of electionTypeButtonsArray" :mode="data.mode" @click="finalResultTypeButtonsHandler('electionType', data.routeSetValue, this.electionTypeButtonsArray)" buttonType="button" paddingX="14px" paddingY="8px" class="before-large-text font-weight-600" buttonWidth="max-content">
                <template v-slot:content>
                    <p>{{ data.content }}</p>
                </template>
            </primaryButtonComponent>
        </section>
        <section class="exit-poll-wrapper w-100 border-radius-20 p-3 d-flex flex-column align-items-center gap-4" style="min-height: 500px">
            <div class="d-flex justify-content-start align-items-start align-items-xl-center w-100">
                <form class="search-container-form" @submit.prevent="submitExitPollFilters">
                    <fieldset class="filters-wrapper justify-content-start">
                        <Multiselect ref="cityID" v-model="exitPollFiltersInfoObj.cityID" :options="this.exitPollMultiselectArray[1].options" :mode="this.exitPollMultiselectArray[1].mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 2, true, true, exitPollMultiselectArray, exitPollFiltersInfoObj)" @deselect="() => blockNextMultiselects(2, exitPollMultiselectArray, exitPollFiltersInfoObj)" @clear="() => blockNextMultiselects(2, exitPollMultiselectArray, exitPollFiltersInfoObj)"
                            class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.exitPollMultiselectArray[1].placeholder" :disabled="this.exitPollMultiselectArray[1].isDisabled" insert/>
                        <Multiselect ref="regionID" v-model="exitPollFiltersInfoObj.regionID" :options="this.exitPollMultiselectArray[2].options" :mode="this.exitPollMultiselectArray[2].mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 3, true, true, exitPollMultiselectArray, exitPollFiltersInfoObj)" @deselect="() => blockNextMultiselects(3, exitPollMultiselectArray, exitPollFiltersInfoObj)" @clear="() => blockNextMultiselects(3, exitPollMultiselectArray, exitPollFiltersInfoObj)"
                            class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.exitPollMultiselectArray[2].placeholder" :disabled="this.exitPollMultiselectArray[2].isDisabled" insert/>
                        <Multiselect ref="districtID" v-model="exitPollFiltersInfoObj.districtID" :options="this.exitPollMultiselectArray[3].options" :mode="this.exitPollMultiselectArray[3].mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="true" locale="ge"
                            class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.exitPollMultiselectArray[3].placeholder" :disabled="this.exitPollMultiselectArray[3].isDisabled" insert/>
                        <button type="submit" class="extra-light-text extra-green-color ms-2" style="font-weight: 600; background-color: transparent;">გაფილტვრა</button>
                    </fieldset>
                </form>
            </div>
            <div class="search-depended-content-grid-wrapper">
                <div class="d-flex flex-column align-items-stretch row-gap-3">
                    <multiColorCard :elementsQuantity="2" borderColor="#1e5eff80">
                        <template v-slot:left>
                            <div class="w-100">
                                <p class="text-start large-text font-weight-600 extra-black-color">გამოკითხული: {{ commonExitPollStatistics.all_count??0 }}</p>
                            </div>
                        </template>
                        <template v-slot:right>
                            <p class="text-start large-text font-weight-600 before-extra-large-text">უბნები: {{ commonExitPollStatistics.district_count??0 }}</p>
                        </template>
                    </multiColorCard>
                    <multiColorCard :elementsQuantity="2" borderColor="#1fd28880">
                        <template v-slot:left>
                            <div class="w-100">
                                <p class="text-start large-text font-weight-600 extra-black-color">ინკოგნიტო: {{ commonExitPollStatistics.incognito_count }}
                                    <span class="light-text font-weight-600 extra-green-color">{{ commonExitPollStatistics.all_count?(commonExitPollStatistics.incognito_count / commonExitPollStatistics.all_count * 100).toFixed(2):0 }}%</span>
                                </p>
                            </div>
                        </template>
                        <template v-slot:right>
                            <p class="text-start large-text font-weight-600 extra-black-color">რეალური: {{ commonExitPollStatistics.realy_count }}
                                <span class="light-text font-weight-600 extra-green-color">{{ commonExitPollStatistics.all_count?(commonExitPollStatistics.realy_count / commonExitPollStatistics.all_count * 100).toFixed(2):0 }}%</span>
                            </p>
                        </template>
                    </multiColorCard>
                    <multiColorCard :elementsQuantity="2" borderColor="#B1B1B1">
                        <template v-slot:left>
                            <div class="w-100">
                                <p class="text-start large-text font-weight-600 extra-black-color">ქალი: {{ commonExitPollStatistics.woman_count }}
                                    <span class="light-text font-weight-600 extra-green-color">{{ commonExitPollStatistics.all_count?(commonExitPollStatistics.woman_count / commonExitPollStatistics.all_count * 100).toFixed(2):0 }}%</span>
                                </p>
                            </div>
                        </template>
                        <template v-slot:right>
                            <p class="text-start large-text font-weight-600 extra-black-color">კაცი: {{ commonExitPollStatistics.men_count }}
                                <span class="light-text font-weight-600 extra-green-color">{{ commonExitPollStatistics.all_count?(commonExitPollStatistics.men_count / commonExitPollStatistics.all_count * 100).toFixed(2):0 }}%</span>
                            </p>
                        </template>
                    </multiColorCard>
                    <div class="d-flex flex-column align-items-start justify-content-center gap-1">
                        <h6 class="light-text extra-gray-color font-weight-600">ასაკობრივი მონაცემები</h6>
                        <ul class="data-according-to-range w-100" v-if="commonExitPollStatistics.ageRanges">
                            <li v-for="(key, i) of Object.keys(commonExitPollStatistics.ageRanges)" class="d-flex align-items-center gap-2 gap-xxl-3">
                                <h6 class="large-text extra-gray-color">{{key}}</h6>
                                <div class="d-flex align-items-center gap-1">
                                    <span class="light-text font-weight-600 extra-black-color">{{commonExitPollStatistics.ageRanges[key]}}</span>
                                    <span class="light-text font-weight-600 extra-green-color">{{ commonExitPollStatistics.all_count?(commonExitPollStatistics.ageRanges[key] / commonExitPollStatistics.all_count * 100).toFixed(2):0 }}%</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="d-flex flex-column align-items-stretch w-100 gap-2">
                    <div class="d-flex flex-column align-items-start w-100">
                        <ul class="d-flex flex-column align-items-start gap-2 w-100">
                            <li @click="activateModalMode('დეტალურად:', 'ოპოზიცია', true, 'party'), commonExitPollStatisticsForModal = getCommonExitPollStatistics(rawData, true, false, 'ოპოზიცია')" class="d-flex align-items-center justify-content-start gap-5 w-100 cursor-pointer">
                                <h3 class="before-extra-large-text extra-black-color text-start" style="width: 100px;">ოპოზიცია</h3>
                                <customProgressLine commonBackgroundColor="#1FD286" :progressLineFillLevel="`${positionsObj.opposition?(positionsObj.opposition.sum_prc).toFixed(2):0}%`" :showTitle="false" :showRightInfo="false" :showMainSpecifier="false" progressLineHeight="20px">
                                    <template v-slot:inner-left-info>
                                        <h3 class="before-extra-large-text extra-black-color extra-green-color">{{ `${positionsObj.opposition?(positionsObj.opposition.sum_prc).toFixed(2):0}%` }}</h3>
                                    </template>
                                </customProgressLine>
                            </li>
                            <li @click="activateModalMode('დეტალურად:', 'პოზიცია', true, 'party'), commonExitPollStatisticsForModal = getCommonExitPollStatistics(rawData, true, false, 'პოზიცია')" class="d-flex align-items-center justify-content-start gap-5 w-100 cursor-pointer">
                                <h3 class="before-extra-large-text extra-black-color text-start" style="width: 100px;">პოზიცია</h3>
                                <customProgressLine commonBackgroundColor="#1E5EFF" :progressLineFillLevel="`${positionsObj.position?(positionsObj.position.sum_prc).toFixed(2):0}%`" :showTitle="false" :showRightInfo="false" :showMainSpecifier="false" progressLineHeight="20px">
                                    <template v-slot:inner-left-info>
                                        <h3 class="before-extra-large-text extra-blue-color">{{ `${positionsObj.position?(positionsObj.position.sum_prc).toFixed(2):0}%` }}</h3>
                                    </template>
                                </customProgressLine>
                            </li>
                        </ul>
                        <hr class="w-100" style="margin-bottom: 0">
                    </div>
                    <div class="party-info-grid-wrapper">
                        <h5 class="extra-large-text font-weight-600 text-start">პარტიების ჭრილში</h5>
                        <ul class="d-flex flex-column align-items-start w-100 gap-3 common-scrollbar common-vertical-overflow">
                            <li class="w-100" v-for="(data, i) of partiesObj">
                                <customProgressLine class="cursor-pointer" @click="activateModalMode('დეტალურად:', `${data.party}`, true, 'party'), commonExitPollStatisticsForModal = getCommonExitPollStatistics(rawData, true, data.partyID,)" commonBackgroundColor="green" :progressLineFillLevel="`${(data.sum_prc).toFixed(2)}%`" progressLineHeight="20px">
                                    <template v-slot:main-specifier>
                                        <h6 class="extra-large-text font-weight-600 border-radius-10 d-flex align-items-center justify-content-center" style="background-color: green; height: 100%; aspect-ratio: 1 / 1; min-width: 40px; color: var(--secondary-background-color)">
                                            {{ data.partyNumber }}
                                        </h6>
                                    </template>
                                    <template v-slot:title>
                                        <h6 class="light-text font-weight-500 text-start party-name">
                                            {{data.party}}
                                        </h6>
                                    </template>
                                    <template v-slot:inner-left-info>
                                        <h3 class="light-text extra-black-color font-weight-500">{{ `${(data.sum_prc).toFixed(2)}%` }}</h3>
                                    </template>
                                    <template v-slot:inner-right-info>
                                        <h3 class="large-text font-weight-600">{{ data.sum_count }}</h3>
                                    </template>
                                </customProgressLine>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <primaryModalComponent :showModal="showModal" maxHeight="781px" maxWidth="1000px" @closeModal="triggerModal">
        <template v-slot:modal-content>
            <div class="d-flex flex-column align-items-center gap-2">
                <h5 class="extra-large-text">
                    {{ `${modalTitle}` }}
                        <span class="extra-green-color">{{ `${modalSubTitle}` }}</span>
                    </h5>
                <div class="detailed-modal-content-grid-wrapper w-100">
                    <div class="d-flex flex-column align-items-stretch row-gap-3 w-100">
                        <multiColorCard :elementsQuantity="2" borderColor="#1e5eff80">
                            <template v-slot:left>
                                <div class="w-100">
                                    <p class="text-start light-text font-weight-600 extra-black-color">გამოკითხული: {{ commonExitPollStatisticsForModal.all_count }}</p>
                                </div>
                            </template>
                            <template v-slot:right>
                                <p class="text-start light-text font-weight-600 before-extra-large-text">უბნები: {{ commonExitPollStatisticsForModal.district_count }}</p>
                            </template>
                        </multiColorCard>
                        <multiColorCard :elementsQuantity="2" borderColor="#1fd28880">
                            <template v-slot:left>
                                <div class="w-100">
                                    <p class="text-start light-text font-weight-600 extra-black-color">ინკოგნიტო: {{ commonExitPollStatisticsForModal.incognito_count }}
                                        <span class="light-text font-weight-600 extra-green-color">{{ commonExitPollStatisticsForModal.allParty_count?(commonExitPollStatisticsForModal.incognito_count / commonExitPollStatisticsForModal.allParty_count * 100).toFixed(2):0 }}%</span>
                                    </p>
                                </div>
                            </template>
                            <template v-slot:right>
                                <p class="text-start light-text font-weight-600 extra-black-color">რეალური: {{ commonExitPollStatisticsForModal.realy_count }}
                                    <span class="light-text font-weight-600 extra-green-color">{{ commonExitPollStatisticsForModal.allParty_count?(commonExitPollStatisticsForModal.realy_count / commonExitPollStatisticsForModal.allParty_count * 100).toFixed(2):0 }}%</span>
                                </p>
                            </template>
                        </multiColorCard>
                        <multiColorCard :elementsQuantity="2" borderColor="#B1B1B1">
                            <template v-slot:left>
                                <div class="w-100">
                                    <p class="text-start light-text font-weight-600 extra-black-color">ქალი: {{ commonExitPollStatisticsForModal.woman_count }}
                                        <span class="light-text font-weight-600 extra-green-color">{{ commonExitPollStatisticsForModal.allParty_count?(commonExitPollStatisticsForModal.woman_count / commonExitPollStatisticsForModal.allParty_count * 100).toFixed(2):0 }}%</span>
                                    </p>
                                </div>
                            </template>
                            <template v-slot:right>
                                <p class="text-start light-text font-weight-600 extra-black-color">კაცი: {{ commonExitPollStatisticsForModal.men_count }}
                                    <span class="light-text font-weight-600 extra-green-color">{{ commonExitPollStatisticsForModal.allParty_count?(commonExitPollStatisticsForModal.men_count / commonExitPollStatisticsForModal.allParty_count * 100).toFixed(2):0 }}%</span>
                                </p>
                            </template>
                        </multiColorCard>
                        <div class="d-flex flex-column align-items-start justify-content-center gap-1">
                            <h6 class="light-text extra-gray-color font-weight-600">ასაკობრივი მონაცემები</h6>
                            <ul class="data-according-to-range w-100">
                                <li v-for="(key, i) of Object.keys(commonExitPollStatisticsForModal.ageRanges)" class="d-flex align-items-center gap-2 gap-xxl-3">
                                    <h6 class="large-text extra-gray-color" style="overflow: hidden; text-wrap: nowrap;">{{ key }}</h6>
                                    <div class="d-flex align-items-center gap-1">
                                        <span class="light-text font-weight-600 extra-black-color">{{ commonExitPollStatisticsForModal.ageRanges[key] }}</span>
                                        <span class="light-text font-weight-600 extra-green-color">{{ commonExitPollStatisticsForModal.allParty_count?(commonExitPollStatisticsForModal.ageRanges[key] / commonExitPollStatisticsForModal.allParty_count * 100).toFixed(2):0 }}%</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="common-table-container common-scrollbar common-vertical-overflow" style="border-radius: 0;">
                        <table class="common-tablee common-table-container common-vertical-overflow">
                            <thead>
                                <tr>
                                    <th>სახელი</th>
                                    <th>გვარი</th>
                                </tr>
                            </thead>
                            <tbody class="common-vertical-overflow">
                                <tr v-for="(data, i) of usersInfoForModal">
                                    <td>{{ data.name }}</td>
                                    <td>{{ data.surename }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <vue-awesome-paginate v-if="exitPollPagingInfo.total != 0"
                        :total-items="exitPollPagingInfo.total"
                        :items-per-page="exitPollPagingInfo.limit"
                        :max-pages-shown="2"
                        v-model="exitPollPagingInfo.offset"
                        :hide-prev-next-when-ends="true"
                        @click="exitPollPaginationClickHandler"
                        class="my-3" style="grid-column: 2 / 3; place-self: center;"
                    />
                </div>
            </div>
        </template>
    </primaryModalComponent>
</template>

<script>
import customProgressLine from '@/components/customProgressLine.vue';
import Multiselect from '@vueform/multiselect';
import multiColorCard from '@/components/multiColorCard.vue';
import primaryModalComponent from '@/components/primaryModalComponent.vue';
import primaryButtonComponent from '@/components/primaryButtonComponent.vue';
export default {
    data(){
        return {
            // for modal>>
            showModal: false,
            modalTitle: "",
            modalSubTitle: "",
            modalMode: null,
            exitPollPagingInfo: {
                limit: 10,
                offset: 1,
                total: 0,
            },
            // for exit poll >>
            activatedFilterMode: 0,
            exitPollFiltersInfoObj: {
                cityID:null,
                regionID: null,
                districtID:null,
            },
            electionTypeButtonsArray: [],
            exitPollMultiselectArray: [
                {
                    
                },
                {
                    placeholder: "ოლქი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: false,
                },
                {
                    placeholder: "უბანი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: true,
                },
                {
                    placeholder: "უბნის ნომერი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: true,
                },
            ],
            filteringPagingInfo: {
                exitPollcityID: null,
                exitPollregionID: null,
                exitPolldistrictID: null,
                electionType: null,
            },
            partiesObj: [],
            commonExitPollStatistics: {},
            commonExitPollStatisticsForModal: {},
            positionsObj: {},
            rawData: [],
            usersInfoForModal: [],
            openedPartyID: null,
            openedPositionKeyWord: null,
        }
    },
    components: {
        customProgressLine,
        Multiselect,
        multiColorCard,
        primaryModalComponent,
        primaryButtonComponent,
    },
    mounted(){
        this.removeAriaHidden();
        this.routerMountMovement(this.$route);
        this.$watch(() => this.exitPollMultiselectArray[1].options, (newOptions, oldOptions) => {
                this.exitPollFiltersInfoObj.cityID = this.exitPollFiltersInfoObj.cityID;
                
                if(this.exitPollFiltersInfoObj.cityID){
                    this.allowNextMultiselect(this.exitPollFiltersInfoObj.cityID, 2, false, false, this.exitPollMultiselectArray, this.exitPollFiltersInfoObj);
                    
                }
            },
            { deep: true }
        );
        this.$watch(() => this.exitPollMultiselectArray[2].options, (newOptions, oldOptions) => {
                this.exitPollFiltersInfoObj.regionID = this.exitPollFiltersInfoObj.regionID;
                if(this.exitPollFiltersInfoObj.regionID){
                    this.allowNextMultiselect(this.exitPollFiltersInfoObj.regionID, 3, false, false, this.exitPollMultiselectArray, this.exitPollFiltersInfoObj);
                }
            },
            { deep: true }
        );
        this.$watch(() => this.exitPollMultiselectArray[3].options, (newOptions, oldOptions) => {
                this.exitPollFiltersInfoObj.regionID = this.exitPollFiltersInfoObj.regionID;
            },
            { deep: true }
        );
    },
    watch: {

    },
    beforeRouteUpdate(to, from, next){
        let isQueriesValid = this.getInfoFromRoute(to);
        if(isQueriesValid){
            if(this.activatedFilterMode == 0){
                this.manageExitPollFilters();
            }else if(this.activatedFilterMode == 1){
                this.manageExitPollFilters();
            }
            next(true);
        }else{
            next(false);
            this.$helper.showSwal("არასწორი მისამართი", "error", "");
        }
        this.activatedFilterMode = 0;
    },
    methods: {
        routerMountMovement(to){
            let isQueriesValid = this.getInfoFromRoute(to);
            
            if(isQueriesValid){
                this.getCitiesAll([this.exitPollMultiselectArray]);
                this.getElectionTypes();
                this.manageExitPollFilters();
            }else{
                this.$router.replace(this.$route.path);
                this.$helper.showSwal("არასწორი მისამართი", "error", "");
            }
            this.activatedFilterMode = 0;

        },
        getInfoFromRoute(to){
            Object.keys(this.filteringPagingInfo).forEach((key) => {
                if(key == "electionType"){
                    this.filteringPagingInfo[key] = to.query[key]??1;
                }else{
                    this.filteringPagingInfo[key] = null;
                    this.filteringPagingInfo[key] = to.query[key]?decodeURIComponent(to.query[key].replace(/%/g, '%25')):null;
                }
            })
            
            let isQueriesValid = Object.keys(this.filteringPagingInfo).every((key) => {
                if(this.filteringPagingInfo[key] == null){
                    return true;
                }else{
                    return this.$helper.checkOptionalNumber(this.filteringPagingInfo[key]);
                }
            });
            return isQueriesValid;
        },
        manageExitPollFilters(){
            Object.keys(this.exitPollFiltersInfoObj).forEach((key) => {
                if(this.filteringPagingInfo[`exitPoll${key}`]){
                    
                    this.exitPollFiltersInfoObj[key] = Number(this.filteringPagingInfo[`exitPoll${key}`]);
                }else{
                    this.exitPollFiltersInfoObj[key] = this.filteringPagingInfo[`exitPoll${key}`];
                }
            })
            if(!this.exitPollFiltersInfoObj.cityID){
                this.blockNextMultiselects(2, this.exitPollMultiselectArray, this.exitPollFiltersInfoObj);
            }else if(!this.exitPollFiltersInfoObj.regionID){
                this.blockNextMultiselects(3, this.exitPollMultiselectArray, this.exitPollFiltersInfoObj);
            }

            if(this.exitPollFiltersInfoObj.cityID){
                this.allowNextMultiselect(this.exitPollFiltersInfoObj.cityID, 2, false, false, this.exitPollMultiselectArray, this.exitPollFiltersInfoObj);
            }else if(this.exitPollFiltersInfoObj.regionID){
                this.allowNextMultiselect(this.exitPollFiltersInfoObj.cityID, 3, false, false, this.exitPollMultiselectArray, this.exitPollFiltersInfoObj);
            }
            this.getExitPollTotalResults();
        },
        submitExitPollFilters(){
            let tempObj = {};
            Object.keys(this.exitPollFiltersInfoObj).forEach((key) => {
                if(this.exitPollFiltersInfoObj[key]){
                    tempObj[`exitPoll${key}`] = this.exitPollFiltersInfoObj[key];
                }
            })
            this.activatedFilterMode = 1;
            let filteredQueries = {};
            Object.keys(this.$route.query).forEach((queryKey) => {
                if(this.exitPollFiltersInfoObj.hasOwnProperty(`${queryKey.slice(8)}`) && queryKey.startsWith("exitPoll")){
                }else{
                    filteredQueries[queryKey] = this.$route.query[queryKey];
                }
            })
            
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...filteredQueries,
                    ...tempObj,
                }
            });
        },
        removeAriaHidden(){
            Array.from(document.querySelectorAll('.multiselect span[aria-hidden]')).forEach((item) => {
                item.removeAttribute('aria-hidden');
            })
            Array.from(document.querySelectorAll('.multiselect .multiselect-search[aria-labelledby]')).forEach((item) => {
                item.removeAttribute('aria-labelledby');
            })
        },
        getCitiesAll(changingArray){
            this.$store.dispatch("getCitiesAll").then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.cityID,
                        label: {
                            ge: `${obj.city} ${obj.pathID?`- ${obj.pathID}`:""}`,
                            en: `${obj.cityeng} ${obj.pathID?`- ${obj.pathID}`:""}`,
                        },
                    });
                }
                changingArray.forEach((destArray) => {
                    destArray[1].options = tempArray;
                    destArray[1].isDisabled = false;
                })
            })
        },
        allowNextMultiselect(value, index, clear, blockNext, changingArray, filterVModelsArray){
            if(value){
                if(index == 1){
                    this.getCities(value, clear, changingArray, filterVModelsArray);
                }else if(index == 2){
                    this.getRegions(value, clear, changingArray, filterVModelsArray);
                }else if(index == 3){
                    this.getDistricts(value, clear, changingArray, filterVModelsArray);
                }
            }
            
            if(index < changingArray.length - 1 && blockNext){
                this.blockNextMultiselects(index + 1, changingArray, filterVModelsArray);
            }
        },
        blockNextMultiselects(index, changingArray, filterVModelsArray){
            
            if(index >= changingArray.length){
                return;
            }
            
            changingArray[index].options = [];
            if(index == 1){
                filterVModelsArray.cityID = null;
                this.getCitiesAll([this.exitPollMultiselectArray]);
            }else if(index == 2){
                filterVModelsArray.regionID = null;
                changingArray[index].isDisabled = true;
            }else if(index == 3){
                filterVModelsArray.districtID = null;
                changingArray[index].isDisabled = true;
            }
            this.blockNextMultiselects(index + 1, changingArray, filterVModelsArray);
        },
        getRegions(valueID, clear, changingArray, filterVModelsArray){
            this.$store.dispatch("getRegions",valueID).then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.regionID,
                        label: {
                            ge: `${obj.region} ${obj.pathID?`- ${obj.pathID}`:""}`,
                            en: `${obj.regioneng} ${obj.pathID?`- ${obj.pathID}`:""}`,
                        },
                    });
                }
                if(clear){
                    filterVModelsArray.regionID = null;
                }
                changingArray[2].options = tempArray;
                changingArray[2].isDisabled = false;
            })
        },
        getDistricts(valueID, clear, changingArray, filterVModelsArray){
            this.$store.dispatch("getDistricts",valueID).then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.districtID,
                        label: {
                            ge: obj.district,
                            en: obj.district,
                        },
                    });
                }
                if(clear){
                    filterVModelsArray.districtID = null;
                }
                changingArray[3].options = tempArray;
                changingArray[3].isDisabled = false;
            })
        },
        getElectionTypes(){
            this.$store.dispatch("getElectionTypes").then((response) => {
                response.data.forEach((electionTypeObj, index) => {
                    this.electionTypeButtonsArray.push({
                        content: electionTypeObj.election_type,
                        routeSetValue: electionTypeObj.election_typeID,
                        mode: this.filteringPagingInfo.electionType?Number(this.filteringPagingInfo.electionType) == electionTypeObj.election_typeID?0:1:index == 0?0:1,
                    });
                });
                
            });
        },
        finalResultTypeButtonsHandler(routeSetKeyWord, routeSetValue, iterationArray){
            let routeSetObj = {};
            routeSetObj[routeSetKeyWord] = routeSetValue;
            iterationArray.forEach((finalResTypeObj, index) => {
                if(routeSetValue == finalResTypeObj.routeSetValue){
                    this.activatedFilterMode = 0;
                    finalResTypeObj.mode = 0;
                    this.$router.push({
                        path: this.$route.path,
                        query: {
                            ...this.$route.query,
                            ...routeSetObj,
                        },
                    });
                }else{
                    finalResTypeObj.mode = 1;
                }
            })
        },
        getExitPollTotalResults(){
            this.$store.dispatch("getExitPollTotalResults", {...this.exitPollFiltersInfoObj, election_typeID: this.filteringPagingInfo.electionType}).then((response) => {
                this.rawData = response.data;
                this.partiesObj = this.getPartiesAmount(response.data);
                this.commonExitPollStatistics = this.getCommonExitPollStatistics(response.data, false, false);
            });
        },
        getCommonExitPollStatistics(iterationArray, isFromModal, partyID, positionKeyWord){
            this.openedPartyID = partyID;
            this.openedPositionKeyWord = positionKeyWord;
            let localeObj = {
                all_count: iterationArray[0]?.all_count,
                district_count: iterationArray[0]?.district_count,
                incognito_count: 0,
                realy_count: 0,
                men_count: 0,
                woman_count: 0,
                ageRanges: {
                    "18 - 24": 0,
                    "25 - 34": 0,
                    "35 - 44": 0,
                    "45 - 54": 0,
                    "55 - 64": 0,
                    "65 +": 0,
                },
                allParty_count: 0,
            };
            iterationArray.forEach((partyObj) => {
                if((!(isFromModal ^ partyID === partyObj.partyID)) || (!(isFromModal ^ positionKeyWord === partyObj.party_type))){
                    localeObj.incognito_count += parseInt(partyObj.incognito_count);
                    localeObj.realy_count += parseInt(partyObj.realy_count);
                    if(partyObj.gender == "კაცი"){
                        localeObj.men_count += parseInt(partyObj.sum_count);
                    }else{
                        localeObj.woman_count += parseInt(partyObj.sum_count);
                    }

                    if(localeObj.ageRanges[partyObj.age_range]){
                        localeObj.ageRanges[partyObj.age_range] += partyObj.sum_count;
                    }else{
                        localeObj.ageRanges[partyObj.age_range] = partyObj.sum_count;
                    }
                    localeObj.allParty_count += partyObj.sum_count;
                }
            });
            if(isFromModal){
                this.getExitPollUsersDetails(partyID, positionKeyWord);
            }

            
            return localeObj;
        },
        getExitPollUsersDetails(partyID, positionKeyWord){
            let party_typeID;
            if(positionKeyWord){
                party_typeID = positionKeyWord=="პოზიცია"?2:1;
            }else{
                party_typeID = 0;
            }
            
            this.$store.dispatch("getExitPollUsersDetails", {partyID: partyID?partyID:0, party_typeID, ...this.exitPollFiltersInfoObj, offset: this.exitPollPagingInfo.offset - 1, limit: this.exitPollPagingInfo.limit, election_typeID: this.filteringPagingInfo.electionType}).then((response) => {
                this.usersInfoForModal = response.data[0];
                this.exitPollPagingInfo.total = response.data[1];
            });
        },
        getPartiesAmount(iterationArray){
            let localeObj = {};
            let positionsLocaleObj = {};
            iterationArray.forEach((partyObj) => {
                if(localeObj[partyObj.partyID]){
                    localeObj[partyObj.partyID].sum_count += parseInt(partyObj.sum_count);
                    localeObj[partyObj.partyID].sum_prc +=  parseFloat(partyObj.sum_prc);
                }else{
                    localeObj[partyObj.partyID] = {
                        sum_count: parseInt(partyObj.sum_count),
                        sum_prc: parseFloat(partyObj.sum_prc),
                        partyNumber: partyObj.party_number,
                        party: partyObj.party,
                        partyID: partyObj.partyID,
                    };
                }

                let localePartyType = "position";
                if(partyObj.party_type == "ოპოზიცია"){
                    localePartyType = "opposition";
                }
                if(positionsLocaleObj[localePartyType]){
                    positionsLocaleObj[localePartyType].sum_count += parseInt(partyObj.sum_count);
                    positionsLocaleObj[localePartyType].sum_prc += parseFloat(partyObj.sum_prc);
                }else{
                    positionsLocaleObj[localePartyType] = {
                        sum_count: parseInt(partyObj.sum_count),
                        sum_prc: parseFloat(partyObj.sum_prc),
                    };
                }
                
            });
            this.positionsObj = positionsLocaleObj;
            
            return localeObj;
        },
        exitPollPaginationClickHandler(value){
            let party_typeID;
            if(this.openedPositionKeyWord){
                party_typeID = this.openedPositionKeyWord=="პოზიცია"?2:1;
            }else{
                party_typeID = 0;
            }
            this.$store.dispatch("getExitPollUsersDetails", {partyID: this.openedPartyID?this.openedPartyID:0, party_typeID, ...this.exitPollFiltersInfoObj, offset: value - 1, limit: this.exitPollPagingInfo.limit}).then((response) => {
                this.usersInfoForModal = response.data[0];
                this.exitPollPagingInfo.total = response.data[1];
            });
        },
        // for modal >>
        activateModalMode(modalTitle, modalSubTitle, isOpen, modalMode){
            this.modalMode = modalMode;
            this.modalTitle = modalTitle;
            this.modalSubTitle = modalSubTitle;
            this.triggerModal(isOpen);
        },
        triggerModal(value){
            if(!value){
                this.commonExitPollStatisticsForModal = {};
                this.usersInfoForModal = [];
                this.exitPollPagingInfo.offset = 1;
                this.exitPollPagingInfo.total = 0;
                this.openedPartyID = null;
                this.openedPositionKeyWord = null;
            }
            this.showModal = value;
        },
    }
}
</script>

<style scoped>
.home-container{
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(1, min-content);
    row-gap: .5em;
    overflow: hidden;
}
.exit-poll-wrapper{
    background-color: var(--secondary-background-color);
}
.search-container-form{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1em;
}
.search-container-form .filters-wrapper{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    align-items: center;
    gap: 15px;
}
.search-container-form .filters-wrapper .multiselect{
    --ms-placeholder-color: var(--light-blue);
    --ms-tag-bg: var(--light-blue);
    --ms-option-bg-selected: var(--light-blue);
    --ms-option-bg-selected-pointed: var(--light-blue);
    flex: 1;
    max-width: 235px;
    margin: 0;
}
.search-depended-content-grid-wrapper{
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 1em;
}
.data-according-to-range{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, auto);
    grid-auto-flow: row;
    gap: 1em;
}

.party-info-grid-wrapper{
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: min-content 360px;
    row-gap: 1em;
}
.detailed-modal-content-grid-wrapper{
    display: grid;
    grid-template-columns: 60% 40%;
    grid-template-rows: 1fr;
    max-height: 550px;

}
.common-tablee th{
    padding: 0px 10px 5px 10px;
    font-weight: 500;
    white-space: nowrap;
    text-align: start;
}
.common-tablee td{
    padding: 5px 10px;
    max-width: 200px;
    white-space: wrap;
    overflow: hidden;
    text-align: start;
}
.party-name{
    white-space: nowrap; 
    overflow: hidden; 
    text-overflow: ellipsis; 
    max-width: 700px;
}
@media screen and (max-width: 2000px) {
    .party-name{
        max-width: 600px;
    }
}
@media screen and (max-width: 1800px) {
    .search-container-form .filters-wrapper .multiselect{
        max-width: 170px;
    }
}
@media screen and (max-width: 1750px) {
    .data-according-to-range{
        gap: 1em;
    }
    .party-name{
        max-width: 500px;
    }
}
@media screen and (max-width: 1720px){
    .detailed-modal-content-grid-wrapper{
        max-height: 500px;
    }
}
@media screen and (max-width: 1560px) {
    .data-according-to-range{
        gap: 0.7em;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(3, auto);
    }
    .party-info-grid-wrapper{
        grid-template-rows: min-content 340px;
    }
    .party-name{
        max-width: 400px;
    }
    .detailed-modal-content-grid-wrapper{
        max-height: 450px;
    }
}
@media screen and (max-width: 1310px) {
    .search-container-form .filters-wrapper .multiselect{
        min-width: 120px;
    }
    .party-name{
        max-width: 300px;
    }
    .data-according-to-range{
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(3, auto);
    }
}
</style>